document.addEventListener('DOMContentLoaded', function () {
  function initializeSwiper() {
    const ugcCarousel = document.querySelector('.swiper-container.ugc-carousel');
    if (!ugcCarousel) return;

    const swiper = new Swiper(ugcCarousel, {
      slidesPerView: 1,
      loop: false,
      lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
      pagination: { el: '.slider__pagination', clickable: true },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: { 640: { slidesPerView: 2 }, 992: { slidesPerView: 3 }, 1200: { slidesPerView: 4 } },
    });


    // Add slideChange event after Swiper initialization
    swiper.on('slideChange', () => {
      setTimeout(() => {
        const activeSlides = swiper.slides.filter(slide => 
          slide.classList.contains('swiper-slide-active') || 
          slide.classList.contains('swiper-slide-next')
        );
        document.querySelectorAll('.video-section__media video').forEach(video => {
          if (!video.paused) {
            const parentSlide = video.closest('.swiper-slide');
            if (!activeSlides.includes(parentSlide)) {
              video.pause();
              const button = video.closest('.video-section__media').querySelector('.video_play_pause');
              if (button) {
                button.classList.add('video_play_pause--paused');
                button.classList.remove('video_playing');
                button.setAttribute('aria-label', 'Play video');
              }
            }
          }
        });
      }, 300);
    });

    // Play next video when current video ends
    function playNextVideo(currentVideo) {
      const allVideos = Array.from(document.querySelectorAll('.video-section__media video'));
      const currentIndex = allVideos.indexOf(currentVideo);
      const totalSlides = swiper.slides.length;
      const currentSlideIndex = swiper.realIndex;

      // Use swiper.params.slidesPerView to get the current number of visible slides
      const slidesPerView = swiper.params.slidesPerView;

      // Calculate the index of the last video in the current view
      const lastVideoIndexInView = Math.min(currentSlideIndex + slidesPerView - 1, totalSlides - 1);
      const isLastVideo = currentIndex === lastVideoIndexInView;

      const nextIndex = (currentIndex + 1) % allVideos.length;
      const nextVideo = allVideos[nextIndex];
      const nextSlide = nextVideo.closest('.video-item');
      const nextPlayPauseButton = nextSlide.querySelector('.video_play_pause');
      const nextMuteUnmuteButton = nextSlide.querySelector('.video_mute_unmute');

      // Only navigate to next slide if the current video is the last in view
      if (isLastVideo) {
        swiper.slideNext(); // Move one slide at a time
      }

      // Play next video
      if (nextVideo && nextPlayPauseButton) {
        // Pause all other videos first
        pauseAllOtherVideos(nextVideo);

        // Ensure video is unmuted and attempt to play
        setTimeout(() => {
          // Ensure video is unmuted and attempt to play
          nextPlayPauseButton.click();
          if (!nextMuteUnmuteButton.classList.contains('video_unmuted')) {
            nextMuteUnmuteButton.click();
          }
        }, 300);
      }
    }

    // Add event listener for video end
    document.querySelectorAll('.video-section__media video').forEach((video) => {
      video.addEventListener('ended', () => {
        video.closest('.video-item').querySelector('.video_play_pause').classList.remove('video_playing');
        playNextVideo(video);
      });
    });

    return swiper;
  }

  // Pause all videos except the current one
  function pauseAllOtherVideos(currentVideo) {
    document.querySelectorAll('.video-section__media video').forEach((video) => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
        const button = video.closest('.video-section__media').querySelector('.video_play_pause');
        if (button) {
          button.classList.add('video_play_pause--paused');
          button.classList.remove('video_playing');
          button.setAttribute('aria-label', 'Play video');
        }
      }
    });
  }

  document.querySelectorAll('.video-section__media').forEach((deferredMedia) => {
    const playPauseButton = deferredMedia.querySelector('.video_play_pause');
    const muteUnmuteButton = deferredMedia.querySelector('.video_mute_unmute');

    function getVideoElement() {
      return deferredMedia.querySelector('video');
    }

    function togglePlayPause(video, button) {
      if (video.paused) {
        pauseAllOtherVideos(video); // Pause all other videos before playing
        video.play().then(() => {
          button.classList.remove('video_play_pause--paused');
          button.classList.add('video_playing');
          button.setAttribute('aria-label', 'Pause video');
        }).catch((err) => console.warn('Video play error:', err));
      } else {
        video.pause();
        button.classList.add('video_play_pause--paused');
        button.classList.remove('video_playing');
        button.setAttribute('aria-label', 'Play video');
      }
    }

    if (playPauseButton) {
      playPauseButton.addEventListener('click', () => {
        const video = getVideoElement();
        if (video) togglePlayPause(video, playPauseButton);
      });
      playPauseButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const video = getVideoElement();
          if (video) togglePlayPause(video, playPauseButton);
        }
      });
    }

    function toggleMuteUnmute(video, button) {
      video.muted = !video.muted;
      button.classList.toggle('video_muted', video.muted);
      button.classList.toggle('video_unmuted', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    if (muteUnmuteButton) {
      muteUnmuteButton.addEventListener('click', () => {
        const video = getVideoElement();
        if (video) toggleMuteUnmute(video, muteUnmuteButton);
      });
      muteUnmuteButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const video = getVideoElement();
          if (video) toggleMuteUnmute(video, muteUnmuteButton);
        }
      });
    }
  });

  // Dynamically load Swiper
  function loadSwiper() {
    return new Promise((resolve, reject) => {
      if (typeof Swiper !== 'undefined') {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/swiper/swiper-bundle.min.js';
      script.onload = resolve;
      script.onerror = () => reject(new Error('Failed to load Swiper'));
      document.head.appendChild(script);
    });
  }

  loadSwiper()
    .then(() => initializeSwiper())
    .catch((err) => {
      console.error('Swiper loading error:', err);
      const carousel = document.querySelector('.swiper-container.ugc-carousel');
      if (carousel) {
        carousel.innerHTML = '<p>Sorry, the carousel failed to load. Please try again later.</p>';
      }
    });
});